/**
 * http://usejsdoc.org/
 */
import { EventEmitter } from 'events';
import { resolve } from 'path';

import Api from '../services/authapi';
import loadStore from './loads-store';

class Auth extends EventEmitter {


    constructor() {
        super();
        this.prefix = 'AUTH_STORE_';
        this.auth_token = "";
        this.isLoggedIn = false;
        this.ip = ""
    }
    setListeners = (socket) => {
        socket.on("user_settings", data => {
            this.emitResults({ data }, 'settings');
        });
    }
    verifyEmail = (payload) => {
        return new Promise((resolve, reject) => {
            Api.verifyEmail(payload).then((r) => {
                if (r.status == 200) {
                    resolve(r.data);
                } else {
                    //console.log(r);
                    resolve(r.data);
                }
            })
                .catch((err) => {
                    this.emitError({ message: 'Something went wrong' });
                    reject(err);
                });
        });
    }

    login = (payload) => {
        return new Promise((resolve, reject) => {
            Api.login(payload).then((r) => {
                console.log("🚀 ~ file: auth-store.js ~ line 42 ~ Auth ~ Api.login ~ r", r)
                if (r.status == 200) {
                    if (r.data.success) {
                        if (r.data.isVerified) {
                            this.auth_token = r.data.token;
                            this.isLoggedIn = true;
                            loadStore.displayOnly = r.data.displayOnly;
                            localStorage.setItem("displayOnly", r.data.displayOnly);
                            if (r.data.role) {
                                localStorage.setItem("role", r.data.role);
                            } else {
                                localStorage.setItem("role", '');
                            }
                            this.emitResults({ message: "logged in" }, "loggedIn")
                            resolve(r.data);
                        } else {
                            reject({ message: "Account not verified" });
                        }
                    }
                    reject({ message: "incorrect credentials" });
                } else {
                    //console.log(r);
                    this.emitError({ message: 'Could not sign in, please contact support.' });
                    resolve(r.data);
                }
            })
                .catch((err) => {
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }

    logout = () => {
        return new Promise((resolve, reject) => {
            Api.logout()
                .then(r => {
                    // console.log("🚀 ~ file: auth-store.js ~ line 77 ~ Auth ~ returnnewPromise ~ r", r)
                    resolve('success');

                })
                .catch(err => {
                    reject('error')
                    // console.log('Logiout: ',err)
                })
        })
    }
    getIp = () => {
        //alert('getting ip');
        return new Promise((resolve, reject) => {
            Api.getIp().then((r) => {
                if (r.status == 200) {
                    //console.log(r.data);
                    //alert(JSON.stringify(r.data));
                    console.log(r.data);
                    console.log(r.data.ip);
                    this.ip = r.data.ip;
                    if (this.ip === window.ENV?.localIp) {
                        loadStore.displayOnly = true;
                        this.emitResults({ message: "logged in" }, "loggedIn")
                    }
                    this.emitResults(r.data, "getIp");
                    resolve(r.data);
                    reject({ message: "incorrect credentials" });

                } else {
                    //console.log(r);
                    //alert('error');
                    console.log(r.data);
                    this.emitError({ message: 'Could not sign in, please contact support.' });
                    resolve(r.data);
                }
            })
                .catch((err) => {
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }
    getIpFromAuthStore = () => {
        return this.ip;
    }


    signUp = (payload) => {
        return new Promise((resolve, reject) => {
            Api.signUp(payload).then((r) => {
                if (r.status == 200) {
                    if (r.data) {
                        this.emitResults({ message: "Please check email to verify" }, "loggedIn")
                        resolve(r);
                    }
                } else {
                    //console.log(r);
                    this.emitError({ message: 'Could not sign in, please contact support.' });
                    resolve(r.data);
                }
            })
                .catch((err) => {
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }
    
    ChangeUserSettings = (payload) => {
        return new Promise((resolve, reject) => {
            Api.changeSettings(payload).then((r) => {
                if (r.status == 200) {
                    if (r.data) {
                        // this.emitResults({ message: "Please check email to verify" }, "loggedIn")
                        resolve(r);
                    }
                } else {
                    //console.log(r);
                    this.emitError({ message: 'Could not change settings, please contact support.' });
                    resolve(r.data);
                }
            })
                .catch((err) => {
                    this.emitError({ message: 'Incomplete or Invalid data present' });
                    reject(err);
                });
        });
    }
    forgotPassword = (data) => {
        return new Promise((resolve, reject) => {
            Api.forgot(data).then(res => {
                if (res.status === 200) {
                    if (res.data.success) {
                        this.emitResults({ message: "Email is sent Successfully" }, "resetPassword")
                        resolve(res);
                    }
                }
                else {
                    this.emitError({ message: 'Please input correct email.' })
                    resolve(res);
                }
            })
                .catch(err => {
                    this.emitError({ message: 'Error, Please try again.' })
                    reject(err);
                })
        })
    }

    resetPassword = (data) => {
        return new Promise((resolve, reject) => {
            Api.resetPassword(data)
                .then(res => {
                    if (res.status === 200) {
                        if (res.data.success) {
                            this.emitResults({ message: "Reset success" })
                            resolve(res);
                        }
                        else {
                            this.emitError({ message: "Please Try again" })
                            resolve(res);
                        }
                    }
                })
                .catch(err => {
                    this.emitError({ message: 'Server error' })
                    reject(err);
                })
        })
    }

    dataLoaded = () => {
        this.emitResults({ message: "data Loaded" }, "dataLoaded");
    }

    getAuthToken = () => {
        return this.auth_token;
    }

    isLoggedIn = () => {
        return this.isLoggedIn;
    }
    getSettingsByUser = () => {
        console.log("getSettingsByUser")
        return new Promise((resolve, reject) => {
            Api.getSettingsByUser()
                .then(res => {
                    if (res.status === 200) {
                        if (res.data) {
                            let m = { data: res.data }
                            this.emitResults(m, 'settings')
                        }
                        else {
                            this.emitError({ message: "Please Try again" })
                        }
                    }
                })
                .catch(err => {
                    this.emitError({ message: 'Server error' })
                    reject(err);
                })
        })
    }
    updateSettingsOfUser = (payload) => {
        return new Promise((resolve, reject) => {
            Api.updateSettingsOfUser(payload)
                .then(res => {
                    if (res.status === 200) {
                        if (res.data) {
                            let m = { data: res.data }
                            this.emitResults(m, 'settings')
                        }
                        else {
                            this.emitError({ message: "Please Try again" })
                        }
                    }
                })
                .catch(err => {
                    this.emitError({ message: 'Server error' })
                    reject(err);
                })
        })
    }

    emitError = (err) => {
        var payload = { ...err };
        this.emit('ERROR', payload);
    }

    getEventPrefix = (func) => {
        return `${this.prefix}${func}`;
    }

    emitResults = (r, func) => {
        if (!r.data) {
            //console.log(r);
            this.emitError({ alert: true, message: 'No Slots found' });
        }
        this.setMaxListeners(1000);
        this.emit(`${this.prefix}${func}`, r.data);
    }

    emitDate = (r, func) => {

        this.emit(`${this.prefix}${func}`, r);
    }

    debug = (r) => {
        //console.log(r.data);
    }
}
const authStore = new Auth();
window.authStore = authStore;
export default authStore;
